import React, { useState } from "react";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import "./App.css";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="App">
      {/* Navbar */}
      <nav className="navbar">
        <div className="container">
          <div className="logo-text">
            THE <span>CYPHER</span> GAMING LOUNGE
          </div>

          <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
            <li>
              <a href="#home">HOME</a>
            </li>
            <li>
              <a href="#services">SERVICES</a>
            </li>
            <li>
              <a href="#pricing">PRICING</a>
            </li>
            <li>
              <a href="#booking">BOOK</a>
            </li>
            <li>
              <button className="franchise-btn">FRANCHISE</button>
            </li>
          </ul>

          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        </div>
      </nav>

      {/* Hero Section (VIDEO) */}
      <header className="hero" id="home">
        <video autoPlay muted loop playsInline className="hero-video">
          <source src="/hero.mp4" type="video/mp4" />
        </video>

        <div className="hero-overlay">
          <h1 className="neon-text">JOIN THE CYPHER</h1>
          <p>Elevate Your Gaming Experience</p>
          <button className="cta-main">EXPLORE NOW</button>
        </div>
      </header>

      {/* Services */}
      <section id="services" className="services">
        <h2>OUR SERVICES</h2>

        <div className="services-grid">
          <div className="service-card bg-gaming">
            <div className="overlay">
              🎮
              <h3>Gaming Café</h3>
              <p>High-end RTX PCs</p>
            </div>
          </div>

          <div className="service-card bg-billiards">
            <div className="overlay">
              🎱
              <h3>Billiards</h3>
              <p>Pro-grade tables</p>
            </div>
          </div>

          <div className="service-card bg-racing">
            <div className="overlay">
              🏎️
              <h3>Racing Sims</h3>
              <p>Immersive setups</p>
            </div>
          </div>

          <div className="service-card bg-cafe">
            <div className="overlay">
              🍕
              <h3>Café</h3>
              <p>Food & drinks</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="pricing">
        <h2>PRICING</h2>

        <div className="pricing-grid">
          <div className="price-card glow">
            <h3>Gaming PCs</h3>
            <p className="price">₹80 / hour</p>
            <span>RTX 5060 • 240Hz</span>
          </div>

          <div className="price-card glow">
            <h3>Night Pass</h3>
            <p className="price">₹500</p>
            <span>10 PM – 6 AM</span>
          </div>

          <div className="price-card glow">
            <h3>PS5 / PS VR Experience</h3>
            <p className="price">₹150 - ₹250 / hour</p>
            <span>4K • Couch Co-op</span>
          </div>

          <div className="price-card glow">
            <h3>Pool / Snooker</h3>
            <p className="price">₹150 – ₹300</p>
            <span>Per table</span>
          </div>
        </div>

        {/* CTA */}
        <div className="pricing-note">
          <p>
            🎮 For memberships, combo packs & exclusive offers — visit our
            gaming loungé.
          </p>
          <a
            href="https://wa.me/7588225424"
            target="_blank"
            rel="noreferrer"
            className="cta-main"
          >
            Enquire Now
          </a>
        </div>
      </section>

      {/* Booking */}
      <section id="booking" className="booking">
        <h2>BOOK YOUR SLOT</h2>
        <a
          href="https://wa.me/7588225424?text=I want to book a gaming slot at The Cypher"
          target="_blank"
          rel="noreferrer"
          className="cta-main"
        >
          Book on WhatsApp
        </a>
      </section>

      <section id="location" className="location">
        <h2>VISIT US</h2>

        <div className="location-container">
          {/* Address */}
          <div className="location-info">
            <h3>THE CYPHER GAMING LOUNGE</h3>

            <p>
              Shop No. 2, Khalde Mala
              <br />
              Mantra City Road, Talegaon Dabhade
              <br />
              Maharashtra – 410507
            </p>

            <a
              href="https://maps.app.goo.gl/uc4CNZ1WjAemrNec6"
              target="_blank"
              rel="noreferrer"
              className="cta-main"
            >
              📍 Open in Google Maps
            </a>

            <p className="branch-note">🚀 more locations coming soon!</p>
          </div>

          {/* Map */}
          <div className="map">
            <iframe
              src="https://www.google.com/maps?q=Talegaon%20Dabhade%20410507&output=embed"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Cypher Location"
            ></iframe>
          </div>
        </div>
      </section>

      <footer>
        <p>THE CYPHER GAMING LOUNGE © 2025</p>
        <div className="socials">
          <a
            href="https://www.instagram.com/the_cyph3r_gaming_lounge/"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61585254815865"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookF />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
